/** Tracks observed continuity; elapsed time without a sample never earns health. */
export class ContinuousHealthEvidence {
  private lastAtMs?: number;

  public observe(atMs: number): boolean {
    const previous = this.lastAtMs;
    this.lastAtMs = Number.isFinite(atMs) ? atMs : undefined;
    return Number.isFinite(atMs) && (previous === undefined
      || (atMs > previous && atMs - previous < 3_000));
  }

  public invalidate(): void { this.lastAtMs = undefined; }

  public static fresh(nowMs: number, sampledAtMs: number | undefined): boolean {
    return sampledAtMs !== undefined && Number.isFinite(sampledAtMs)
      && Number.isFinite(nowMs) && nowMs >= sampledAtMs && nowMs - sampledAtMs < 3_000;
  }

  public static transitAge(nowMs: number, bounds?: { earliestMs: number; latestMs: number }): number | undefined {
    if (!bounds || !Number.isFinite(nowMs) || !Number.isFinite(bounds.earliestMs)
      || !Number.isFinite(bounds.latestMs) || bounds.earliestMs > bounds.latestMs
      || bounds.earliestMs > nowMs) return undefined;
    return nowMs - bounds.earliestMs;
  }
}
